import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLearnerMode, isLearnerPathAllowed } from '../hooks/useLearnerMode';

// In programmes-only mode, signed-in learners can only reach dashboard, profile, programmes and programme content players.
export function LearnerModeGuard({ children }) {
  const { isAuthenticated, isAdmin, loading, user } = useAuth();
  const { programmesOnly, loaded } = useLearnerMode();
  const location = useLocation();

  if (loading || !loaded || !isAuthenticated || isAdmin || !programmesOnly) return children;
  if (!isLearnerPathAllowed(location.pathname, user?.role)) return <Navigate to="/dashboard" replace />;
  return children;
}

// Picks the programmes-only page for learners, the original page otherwise.
export function LearnerAware({ programmesOnlyElement, children }) {
  const { isAdmin } = useAuth();
  const { programmesOnly } = useLearnerMode();
  return !isAdmin && programmesOnly ? programmesOnlyElement : children;
}

export default LearnerModeGuard;
